// Task #4613 — clickable PadSplit emblem shown on PadSplit-synced tasks.
// Renders "PS <padsplitTaskId>" and, when the property's PadSplit ID is
// resolvable, links out to the task on PadSplit in a new tab. Clicks must
// never bubble into the task card (which opens the detail sheet) or start a
// Kanban drag, so both click and pointer/mouse-down stop propagation.
import { ExternalLink } from "lucide-react";

export function buildPadsplitTaskUrl(
  padsplitPropertyId: string | number | null | undefined,
  padsplitTaskId: string | number | null | undefined,
): string | null {
  if (padsplitPropertyId == null || padsplitPropertyId === "" || padsplitTaskId == null || padsplitTaskId === "") {
    return null;
  }
  return `https://padsplit.com/host/task/${padsplitPropertyId}/${padsplitTaskId}`;
}

export function PadsplitTaskEmblem({
  padsplitTaskId,
  padsplitPropertyId,
  testId,
}: {
  padsplitTaskId: string | number;
  padsplitPropertyId: string | number | null | undefined;
  testId: string;
}) {
  const url = buildPadsplitTaskUrl(padsplitPropertyId, padsplitTaskId);
  const baseClass =
    "inline-flex items-center gap-1 h-5 px-1.5 rounded-full bg-brand text-white text-[10px] font-semibold leading-none";

  if (!url) {
    // Synced but the PadSplit property ID isn't resolvable — show the ID
    // without a broken link.
    return (
      <span
        className={baseClass}
        title={`PadSplit task ${padsplitTaskId}`}
        data-testid={testId}
      >
        PS {padsplitTaskId}
      </span>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`${baseClass} hover:opacity-90 cursor-pointer`}
      title="View on PadSplit"
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      PS {padsplitTaskId}
      <ExternalLink className="h-2.5 w-2.5" aria-hidden="true" />
    </a>
  );
}
